/**
 * Article Mover
 * Manages moving articles between feature column and slider
 */
export default class ArticleMover {
    featureColumn: JQuery<HTMLElement>;
    articleSlides: JQuery<HTMLElement>;

    /**
     * @param featureColumn - Feature article column
     * @param articleSlides - Slider container
     */
    constructor(featureColumn: JQuery<HTMLElement>, articleSlides: JQuery<HTMLElement>) {
        this.featureColumn = featureColumn;
        this.articleSlides = articleSlides;
    }

    /**
     * Moves feature article to slider
     */
    moveToSlider(): void {
        const featureArticle = this.featureColumn.children('article').first();

        if (featureArticle.length) {
            this.articleSlides.prepend(featureArticle);
        }
    }

    /**
     * Moves first article to feature column
     */
    moveToFeature(): void {
        const firstArticle = this.articleSlides.children('article').first();

        if (firstArticle.length) {
            // Move existing feature article back to slider first to avoid duplicates
            const existingFeature = this.featureColumn.children('article').first();
            if (existingFeature.length) {
                this.articleSlides.prepend(existingFeature);
            }

            this.featureColumn.append(firstArticle);
        }
    }
}

